import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachDealersToGroup } from '../services/security-groups';

type AttachVars = { dealer_ids: string[]; include_descendants?: boolean };

export function useAttachDealersMutation(groupId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (vars: AttachVars) => attachDealersToGroup(groupId, vars),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId, 'dealers'] });
      queryClient.invalidateQueries({ queryKey: ['security-group', groupId] });
      queryClient.invalidateQueries({ queryKey: ['security-groups'] });
    },
  });
}
